import InstructionStore from '../scenes/Instruction/store'
import CallbackStore from '../scenes/Callback/store'

export default  class App {
  constructor(rootStore) {
    this.rootStore = rootStore
    this.instructionStore = new InstructionStore ( this )
    this.callbackStore = new CallbackStore ( this )
  }
}